import { IBaseModel } from './base.model';

export type BeneficiaryRelationship =
  | 'Spouse'
  | 'Child'
  | 'Parent'
  | 'Sibling'
  | 'Other'
  | 'Husband'
  | 'Wife'
  | 'Daughter'
  | 'Mother'
  | 'Grandmother'
  | 'Grandfather'
  | 'Father'
  | 'Son'
  | 'Sister'
  | 'GrandParent'
  | 'Relative'
  | 'Friend';

export const RELATIONSHIP_OPTIONS: BeneficiaryRelationship[] = [
  'Husband',
  'Wife',
  'Son',
  'Daughter',
  'Father',
  'Mother',
  'Grandfather',
  'Grandmother',
  'Sister',
  'Relative',
  'Friend',
  'Other',
];

export type BeneficiaryIdType = 'Nrc' | 'Passport' | 'DrivingLicense' | 'Other';

export const ID_TYPE_OPTIONS: BeneficiaryIdType[] = [
  'Nrc',
  'Passport',
  'DrivingLicense',
  'Other',
];

export interface IBeneficiary extends IBaseModel {
  firstName: string;
  lastName: string;
  relationship: BeneficiaryRelationship;
  idNumber: string;
  idType?: BeneficiaryIdType;
  phoneNumber: string;
  email?: string;
  dateOfBirth: Date;
  gender?: string;
  dependantType?: string;
  isNextOfKin?: boolean;
}

export interface IBeneficiaryRequest extends Partial<IBaseModel> {
  firstName: string;
  lastName: string;
  relationship: BeneficiaryRelationship;
  idNumber: string;
  idType?: BeneficiaryIdType;
  phoneNumber: string;
  email?: string;
  dateOfBirth: Date | string;
  isNextOfKin: boolean;
  dependantType?: string;
  gender?: string;
}
